import Vue from "vue";
import Vuex from "vuex";

import app from "./modules/app";
import auth from "./modules/auth";
import data from "./modules/data";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    app,
    data,
  },
  strict: process.env.NODE_ENV !== "production",
});
